// Opens the "New project" dialog from anywhere (Projects page, the navbar New menu, a deep link). The dialog itself is
// NewProjectHost, mounted once in the app shell; this is only the switch, like the toast store.

type Listener = () => void;
let listeners: Listener[] = [];

export function openNewProjectDialog() {
  for (const l of listeners) l();
}

export function onOpenNewProject(listener: Listener) {
  listeners = [...listeners, listener];
  return () => {
    listeners = listeners.filter((l) => l !== listener);
  };
}
